import { createSlice } from '@reduxjs/toolkit';
import type { Reducer } from '@reduxjs/toolkit';
import type { IntlState } from './types';

export const initialState: IntlState = {
  locale: 'en-GB',
};

export const intlSlice = createSlice({
  name: 'intl',
  initialState,
  reducers: {
    setLocale: (state, action: { payload: string }) => {
      state.locale = action.payload;
    },
  },
});

export const { setLocale } = intlSlice.actions;

const reducer: Reducer<IntlState> = intlSlice.reducer;

export default reducer;
